export default __webpack_public_path__ + "static/media/young-woman-opening-oven-kitchen@2x.b14080f7.png";